// 时间戳格式化js
export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
        }
    }
    return fmt
}

function padLeftZero(str) {
    return ('00' + str).substr(str.length)
}

export function formatEnglishDate(timestamp) {
    var dt = new Date(timestamp);

    var m = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
    var mn = dt.getMonth();
    var dn = dt.getDate();
    return m[mn] + " " + dn + "," + dt.getFullYear();

}

export function formatLocalizedDateTime(timestamp, locale) {
    const date = new Date(Number(timestamp == null ? 0 : timestamp));
    const dateText = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    }).format(date);
    const timeText = new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit'
    }).format(date);
    return dateText + '\n' + timeText;
}

export function getDaysByDateString(dateString1, dateString2) {
    // console.log("dateString1====="+dateString1)
    // console.log("dateString1========="+dateString2)
    // dateString1 = new Date(dateString1);
    //获取起始时间的毫秒数
    //其中dateString1.replace('/-/g','/')是将日期格式为yyyy-mm-dd转换成yyyy/mm/dd
    //Date.parse()静态方法的返回值为1970年1月1日午时到当前字符串时间的毫秒数，返回值为整数
    //如果传入的日期只包含年月日不包含时分秒，则默认取的毫秒数为yyyy/mm/dd 00:00:00
    //取的是0时0分0秒的毫秒数，如果传入的是2015/07/03 12:20:12则取值为该时间点的毫秒数
    // var  startDate=Date.parse(dateString1.replace('/-/g','/'));
    // var  endDate=Date.parse(dateString2.replace('/-/g','/'));
    //因为不传时分秒的时候 默认取值到dateString2的0时0分0秒时的毫秒数，这样就不包含当前天数的毫秒数
    //如果计算时要包含日期的当前天，就要加上一天的毫秒数，我的业务需要，将加上了。
    let diffDate = (dateString2 - dateString1) / 86400000;
    //计算出两个日期字符串之间的相差的天数
    // var days=diffDate/86400000;
    //alert(diffDate/(1*24*60*60*1000));
    // console.log(days);
    return Math.round(diffDate);
}
